import { AbilitySubject } from '../auth/authorization/subject.interface';
import { NotificationSeverity } from '../custom-notification/custom-notification.interface';

export enum NotificationType {
  custom = 'custom',
  system = 'system',
  ticket = 'ticket',
  olt = 'olt',
}

export const autoGeneratedNotificationTypes = [
  NotificationType.system,
  NotificationType.ticket,
  NotificationType.olt,
];

/** Lower value is displayed first. */
export enum NotificationSortOrder {
  oltNotApproved = 1,
  oltWithoutSp = 2,
  oltWithoutIsp = 3,
  certificate = 4,
  oltAllowedIsp = 5,
  ticketAssigned = 6,
}

export interface INotification {
  id?: string;
  sortOrder?: NotificationSortOrder;
  text: string;
  kind: AbilitySubject;
  severity: NotificationSeverity;
  message?: string;
  url?: string;
  read?: boolean;
  type?: NotificationType;
}

export function getIconBySeverity(severity: NotificationSeverity | string) {
  switch (severity) {
    case NotificationSeverity.info:
      return 'pi pi-info-circle text-primary-500';
    case NotificationSeverity.warn:
      return 'pi pi-exclamation-circle text-warn-500';
    case NotificationSeverity.danger:
      return 'pi pi-times-circle text-danger-500';
    default:
      return 'pi pi-info-circle';
  }
}
